import { Box, Chip } from "@mui/material";

const CHIP_SX = {
  maxWidth: 260,
  height: 26,
  backgroundColor: "#f1f5f9",
  color: "#334155",
  fontWeight: 500,
  "& .MuiChip-icon": {
    color: "#64748b",
    fontSize: 13,
    display: "flex",
    alignItems: "center",
    ml: 1,
    mr: -0.25,
  },
  "& .MuiChip-label": {
    display: "flex",
    alignItems: "center",
    fontSize: 12,
    lineHeight: 1,
  },
  "& .MuiChip-deleteIcon": {
    fontSize: 16,
    color: "#94a3b8",
    "&:hover": { color: "#64748b" },
  },
};

const FiltrosChips = ({ chips }) => {
  if (!chips?.length) return null;
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1,
      }}
    >
      {chips.map((chip) => (
        <Chip
          key={chip.key}
          size="small"
          onDelete={chip.onDelete}
          icon={<i className={`ph-bold ${chip.icon}`} />}
          label={chip.label}
          sx={CHIP_SX}
        />
      ))}
    </Box>
  );
};

export default FiltrosChips;
